import { AddressForm } from "./address-form";
import { AttachmentForm } from "./attachment-form";
import { ContactForm } from "./contact-form";
import { DocumentForm } from "./document-form";
import { UserForm } from "./user-form";
import { MetadataPutEnum } from "@models/enums/metadata-put-enum";

export interface UserRelationshipForm {
  usuarioForm: UserForm | null;
  usuListCon: ContactForm[] | null;
  usuListDoc: DocumentForm[] | null;
  usuListLog: AddressForm[] | null;
  usuListAne: AttachmentForm[] | null;
  contaBancariaForm: ContaBancariaForm | null;
}

export interface ContaBancariaForm{
  entNrId?: number;
  entTxMetadado?: MetadataPutEnum;
  banNrId: number;
  ageNrId: number;
  cobTxNumeroConta: string;
  cobTxTipoConta: TipoContaBancariaEnum | null;
}

export enum TipoContaBancariaEnum {
  CORRENTE = 'CORRENTE',
  POUPANCA = 'POUPANCA',
  SALARIO = 'SALARIO',
}
